<template>
  <header id="app-header" class="app-header">
    <div class="app-header__container">
      <a href="https://khonsubrandlab.com/" class="app-header__logo-wrapper">
        <img
          src="../../assets/images/logo.svg"
          alt="Khonsu Brand Lab"
          class="app-header__logo"
        />
      </a>

      <button
        :class="[
          'app-header__menu-icon',
          { 'app-header__menu-icon--open': navOpen },
        ]"
        type="button"
        @click="toggleNav()"
      >
        <span class="app-header__menu-icon-line"></span>
        <span class="app-header__menu-icon-line"></span>
        <span class="app-header__menu-icon-line"></span>
      </button>

      <nav class="app-header__nav" ref="headerNav">
        <!-- <div class="app-header__credits" v-if="this.loginstate">
          Credits: {{ creditBalance }}
        </div> -->
        <ul class="app-header__nav-list">
          <li class="app-header__nav-list-item" v-if="!this.loginstate">
            <router-link
              to="/join"
              @click.native="closeNavOnRedirect"
              class="app-header__nav-link"
              >JOIN</router-link
            >
          </li>

          <li class="app-header__nav-list-item">
            <router-link
              to="/about"
              @click.native="closeNavOnRedirect"
              class="app-header__nav-link"
              >ABOUT</router-link
            >
          </li>

<!--          <li class="app-header__nav-list-item">-->
<!--            <a-->
<!--              :href="`${this.blogURL}/`"-->
<!--              @click.native="closeNavOnRedirect"-->
<!--              class="app-header__nav-link"-->
<!--              >HELP</a-->
<!--            >-->
<!--          </li>-->

          <li class="app-header__nav-list-item" v-if="!this.loginstate">
            <router-link
              to="/our-packages"
              @click.native="closeNavOnRedirect"
              class="app-header__nav-link"
              >OUR PACKAGES</router-link
            >
          </li>

          <li class="app-header__nav-list-item" v-if="this.loginstate">
            <router-link
              to="/products"
              @click.native="closeNavOnRedirect"
              class="app-header__nav-link"
              >PRODUCTS</router-link
            >
          </li>

          <li class="app-header__nav-list-item">
            <router-link
              to="/contact"
              @click.native="closeNavOnRedirect"
              class="app-header__nav-link"
              >CONTACT</router-link
            >
          </li>

          <li class="app-header__nav-list-item" v-if="this.loginstate">
            <router-link
              to="/my-account"
              @click.native="closeNavOnRedirect"
              class="app-header__nav-link"
              >MY ACCOUNT</router-link
            >
          </li>

          <li class="app-header__nav-list-item" v-if="this.loginstate">
            <router-link
              to="#"
              @click.native="goToLogOut()"
              class="app-header__nav-link app-header__nav-link--button"
              >Logout</router-link
            >
          </li>

          <li class="app-header__nav-list-item" v-else>
            <router-link
              to="/login"
              @click.native="closeNavOnRedirect"
              class="app-header__nav-link app-header__nav-link--button"
              >Login</router-link
            >
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
// import axios from "axios";
import $ from "jquery";

export default {
  name: "AppHeader",
  computed: {},
  watch: {},
  data() {
    return {
      loginstate: false,
      navOpen: false,
      blogURL: process.env.VUE_APP_BLOG_URL,
      creditBalance: 0,
    };
  },
  methods: {
    goToLogOut: function () {
      this.closeNavOnRedirect();
      this.loginstate = false;
      this.$store.dispatch("UserManagement/logoutUser", {
        user_id: sessionStorage.getItem("user_id"),
      });
    },
    toggleNav: function () {
      if (this.navOpen == false) {
        this.navOpen = true;
        $(this.$refs.headerNav).slideDown();
        document.getElementsByTagName("body")[0].style.overflow = "hidden";
      } else {
        this.navOpen = false;
        $(this.$refs.headerNav).slideUp();
        document.getElementsByTagName("body")[0].style.overflow = "";
      }
    },
    closeNavOnRedirect() {
      if (this.navOpen) {
        this.toggleNav();
      }
    },
    // fetchUserCredits() {
    //     const userId = sessionStorage.getItem('user_id');
    //     axios({
    //         method: 'post',
    //         url: 'http://localhost/api/getCredits',
    //         data: {
    //             userId
    //         },
    //         headers: {
    //             'Content-Type': 'application/json',
    //         }
    //     })
    //     .then(response => {
    //         this.creditBalance = response.data.credits;
    //     })
    //     .catch(error => {
    //         console.error(error);
    //     });
    // }
  },
  mounted() {
    if (sessionStorage.getItem("_khonsu_user_login_status")) {
      this.loginstate = true;
      // this.fetchUserCredits();
      // this.creditInterval = setInterval(this.fetchUserCredits, 5000);  // fetch credits every 5 seconds
    }
  },
  beforeDestroy() {
    clearInterval(this.creditInterval); // clear interval when component is destroyed to prevent memory leaks
  },
};
</script>
